'use client';

import { Button } from '@petsmart-ui/sparky';

import { useMedalliaFeedback } from '@libs/common-next';

import './feedback-button.scss';

const LINK_TEXT = 'Feedback';

export function FeedbackButton() {
    const { formState, onOpen } = useMedalliaFeedback();

    return (
        <Button
            className="condensed-feedback-button"
            aria-label="Open feedback form"
            disabled={formState !== 'ready'}
            onClick={onOpen}
            text={LINK_TEXT}
            type="button"
            variant="link"
        />
    );
}
